import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { SubscriberData } from './subscriber.api'
import { PermissionData } from './permission.api'
import { AddressData } from './address.api'
import { TimezoneData } from './timezone.api'

export interface SiteData {
  id: number
  subscriberId: number
  addressId: number
  timezoneId: number
  name: string
  prefix: string
  capacity: number
  endAt: string
  blockedAt?: string
  createdAt: string
  updatedAt: string
  usersCount: number
  isBlocked: boolean
  isCanceled: boolean
  inPending: boolean
  inTrial: boolean
  subscriber?: SubscriberData
  permissions?: PermissionData[]
  address?: AddressData
  timezone?: TimezoneData
}

interface SiteOccupiedCapacityResponse {
  capacity: number
}

export interface SetupStatusResponse {
  category: boolean
  item: boolean
  location: boolean
}

export interface SiteCreateRequest {
  name?: string
  subscriber?: number
  prefix?: string
  endAt?: string
  capacity?: number
  timezone?: number
  address?: string
  city?: string
  state?: string
  zip?: string
  permissions?: number[]
}

export interface SiteUpdateRequest {
  name?: string
  endAt?: string
  address?: string
  city?: string
  state?: string
  zip?: string
  permissions?: number[]
}

const routes = {
  occupiedCapacity: '/sites/capacity/occupied',
  list: '/sites',
  block: '/sites/{id}/block',
  unblock: '/sites/{id}/unblock',
  create: '/sites',
  read: '/sites/{id}',
  update: '/sites/{id}',
  listPermissions: '/sites/{id}/permissions',
  setupStatus: '/sites/setup/status'
}

export default {
  occupiedCapacity (callback: ResponseCallback<SiteOccupiedCapacityResponse>) {
    api.get(routes.occupiedCapacity, {}, callback)
  },

  list (callback: ResponseCallback<SiteData[]>) {
    api.get(routes.list, {}, callback)
  },

  block (id: number, callback: ResponseCallback<SiteData>) {
    const url = routeUtil.replaceParams(routes.block, { id })
    api.patch(url, {}, callback)
  },

  unblock (id: number, callback: ResponseCallback<SiteData>) {
    const url = routeUtil.replaceParams(routes.unblock, { id })
    api.patch(url, {}, callback)
  },

  create (payload: SiteCreateRequest, callback: ResponseCallback<SiteData>) {
    api.post(routes.create, payload, callback)
  },

  read (id: number, callback: ResponseCallback<SiteData>) {
    const url = routeUtil.replaceParams(routes.read, { id })
    api.get(url, {}, callback)
  },

  update (
    id: number,
    payload: SiteUpdateRequest,
    callback: ResponseCallback<SiteData>
  ) {
    const url = routeUtil.replaceParams(routes.update, { id })
    api.patch(url, payload, callback)
  },

  listPermissions (callback: ResponseCallback<PermissionData[]>, id?: number) {
    const url = routeUtil.replaceParams(routes.listPermissions, { id })
    api.get(url, {}, callback)
  },

  setupStatus (callback: ResponseCallback<SetupStatusResponse>) {
    api.get(routes.setupStatus, {}, callback)
  }
}
